"use client";
import VideoCard from "@/ui/Videocard";
// import Banner from "../Banner";
import SchoolPageBanner from "@/ui/SchoolBanner";
import VideoBanner from "@/ui/VideoBanner";
import RichTextRenderer from "@/ui/Richtextrender";
import Breadcrumbs from "@/components/Breadcrumbs";

const extractText = (richText) => {
  if (!richText) return "";
  if (typeof richText === "string") return richText.trim();
  if (Array.isArray(richText)) {
    return richText.map(extractText).join(" ").trim();
  }
  if (richText.children && Array.isArray(richText.children)) {
    return richText.children
      .map((child) => {
        if (child.type === "text" && child.text) return child.text;
        return extractText(child);
      })
      .join("")
      .trim();
  }
  return "";
};

const AboutSchool = ({ school }) => {
  if (!school) return null;

  const video =
    school.video?.data?.[0]?.attributes ||
    school.video?.attributes ||
    school.video;
  const videothumbnail =
    school.videothumbnail?.data?.[0]?.attributes ||
    school.videothumbnail?.attributes ||
    school.videothumbnail;
  const bannerImage =
    school.bannerImage?.data?.[0]?.attributes ||
    school.bannerImage?.attributes ||
    school.bannerImage;

  const videoUrl = school.VideoUrl;
  const videothumbnailurl =
    videothumbnail?.url || videothumbnail?.formats?.thumbnail?.url;
  const bannerUrl = bannerImage?.url || bannerImage?.formats?.large?.url;

  const banner_name =
    extractText(school?.name) || "School of Management & Commerce";

  const videoBannerUrl = school.Video_Banner;

  return (
    <section className="">
      {videoBannerUrl ? (
        <VideoBanner videoSrc={videoBannerUrl} banner_name={banner_name} />
      ) : (
        <SchoolPageBanner BannerImage={bannerUrl} banner_name={banner_name} />
      )}
      <Breadcrumbs
        items={[
          {
            label: school?.name,
          },
        ]}
      />
      <div className="page-container mt-2 lg:mt-8">
        <div className="mt-4 md:mt-14">
          <div className="text-2xl sm:text-3xl lg:text-[42px] font-saansBold leading-tighter">
            <h1 className="font-saansBold mb-3">{school.Title?.[0]?.children?.[0]?.text || "About The School"}</h1>
          </div>
        </div>
        <div
          className="text-[18px] leading-relaxed"
          style={{ fontFamily: "saans-regular" }}
        >
          <RichTextRenderer
            content={school.description}
            className="prose prose-sm max-w-none"
          />
        </div>
      </div>

      {videoUrl && (
        <div className="w-full page-container mt-4 lg:mt-14">
          <VideoCard videoSrc={videoUrl} thumbnail={videothumbnailurl} />
        </div>
      )}
    </section>
  );
};

export default AboutSchool;
